import { useTranslation } from "react-i18next";
import { CustomModal } from "../../../components/Modal/CustomModal";
import { useNavigate } from "react-router-dom";
import { CustomButton } from "./components/CustomButton";
import { ArrowRightIcon } from "../../../assets/icons/icons.tsx/ArrowRightIcon";
import { ConfirmIcon } from "../../../assets/icons/icons.tsx/ConfirmIcon";
import { useState } from "react";
import { filesSelected } from "../WorkSpaceItemListFile";
import { WorkspaceProps } from "./MoveInBatch";
import { FatherfolderProps } from "../../RecicleBin/GridArchive/GridRestore/RestoreConfirm";
import MovedResult from "./components/MovedResult";
import checkHeader from "../../../assets/icons/checkHeader.svg"

interface RestoreSuccessProps {
  nameOrg: string;
  newWorkspace: WorkspaceProps;
  newFatherFolder?: FatherfolderProps;
  item: filesSelected[];
  isConfirmed: boolean;
  hideModal: () => void;
}

const MovedSuccess: React.FC<RestoreSuccessProps> = ({nameOrg, item, isConfirmed, hideModal, newWorkspace, newFatherFolder }) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  const [isHoveredButtonCancel, setIsHoveredButtonCancel] = useState(false);

  function goToFile(){
    let fatherFolderId = newFatherFolder?.id
    if (newFatherFolder?.id === "undefined") {
      fatherFolderId = undefined;
		}
    
    const url = `/${nameOrg}/wsallowed/${newWorkspace.workspaceId}${fatherFolderId ? `/${fatherFolderId}` : ''}`;
    navigate('/reload-temp', { replace: true });
    setTimeout(() => navigate(url), 0);
    hideModal()
  }

  return (
    <div>
      <CustomModal 
        isModalOpen={isConfirmed}
        hideModal={hideModal}
      >
        <div style={{display:"flex", justifyContent:"center"}}>
          <img src={checkHeader} alt='check'/>
        </div>

        <div style={{width:"100%", display:"flex", justifyContent: "center"}}>            
          <div style={{marginTop:"20px", font:"normal normal 600 20px/39px Segoe UI", color: "#2D2D2D"}}>
            {t("MovedSuccess.title")}
          </div>
        </div>
        <div style={{padding:"10px 0px 10px 0px", display:"flex", justifyContent: "center", width:"100%"}}>
          <div style={{font:"normal normal normal 16px/24px Segoe UI", color: "#575757"}}>
            <div style={{width:"540px", textAlign:"center"}}>
              <div>{t("MovedSuccess.header")}</div>
            </div>
          </div>
        </div>

        {item &&
          <MovedResult
            fatherFolderName={newFatherFolder?.name}
            workspaceName={newWorkspace.workspaceName}
          />
        }

        <div style={{ width: '100%', display: 'flex', gap:"20px" }}>
          <CustomButton 
            icon={<ArrowRightIcon color={isHoveredButtonCancel ? "#FFFFFF" : "#22638D"}/>} 
            onclick={goToFile} 
            setIsHovered={setIsHoveredButtonCancel} 
            text={t("MovedSuccess.goToLocation")}
            backgrondColor='#FCFCFC'
            color='#22638D'
            hoveredBackgrondColor='#0d476d'
            hoveredColor='#FFFFFF'
          />
          <CustomButton 
            icon={<ConfirmIcon/>} 
            onclick={hideModal}  
            text={t("MovedSuccess.finish")}
            backgrondColor='#22638D'
            color='#FFFFFF'
            hoveredBackgrondColor='#0d476d'
          />
        </div>

      </CustomModal>
    </div>
  );
};

export default MovedSuccess;